export default function TransactionsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 16V14H10V16H12V14H14V6H12L15 3L18 6H16V8H20V10H16V14C16 15.1 15.1 16 14 16H10V18H12L9 21L6 18H8V16H4ZM12 10H10V14H8V10C8 8.9 8.9 8 10 8H12V10Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
